import { AnimatePresence, motion } from "motion/react";
import { ReactNode } from "react";

function AnimateCollapse({ children, open }: { children: ReactNode; open: boolean }) {
  return (
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.15 }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default AnimateCollapse;
